
import MuncipleMainComp from "../../components/munciple/MuncipleMainComp"

export const MunicipaltaxPage = ({ title_1, title_2, title }) => {
   
    return <div>
        <MuncipleMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}